import clsx from 'clsx';

const variants = {
	default: 'md:w-[640px] md:max-w-[100%]',
	wide: 'md:w-[640px] lg:w-[1140px]  md:max-w-[100%]',
} as const;

type DefaultViewProps = {
	children: React.ReactElement;
	variant?: keyof typeof variants;
	containerClass?: string;
	isFixedHeight?: boolean; // if true sets a fixed height on the container to allow for a fixed button at the bottom of the screen
};

export const DefaultView = (props: DefaultViewProps) => {
	const { children, variant = 'default', containerClass = '', isFixedHeight = false } = props;

	return (
		<div className='flex flex-col min-h-screen'>
			<div
				className={clsx(
					'md:m-auto md:min-h-[initial] md:h-auto py-8 px-4 md:p-12 bg-white',
					isFixedHeight ? 'h-screen' : 'min-h-screen',
					variants[variant],
					containerClass
				)}
			>
				{children}
			</div>
		</div>
	);
};
